import { assign } from 'xstate';
import {
  BannerError, BannerEvent, BannerState,
} from './types';

export const DefaultMachineId: string = 'BannerStateMachine';

export const DefaultInitialState: BannerState = 'Init';

export const DefaultActions = {
  setError: assign({
    error: (_context, event: { error: BannerError }) => event.error || 'NoRecommendation',
  }),
  cleanError: assign({
    error: () => undefined,
  }),
};

export const DefaultContext = {
  error: undefined,
};

export interface IBannerStateConfig {
  on: Partial<Record<BannerEvent, BannerState | { target: BannerState, actions?: string[] }>>;
}

export interface IBannerMachineConfig {
  id: string;
  initial: BannerState;
  context: any;
  predictableActionArguments: boolean;
  preserveActionOrder: boolean;
  states: Record<BannerState, IBannerStateConfig>;
}

export const BannerMachine: IBannerMachineConfig = {
  id: DefaultMachineId,
  initial: DefaultInitialState,
  context: DefaultContext,
  predictableActionArguments: true,
  preserveActionOrder: true,
  states: {
    Init: {
      on: {
        Generate: 'Generating',
      },
    },
    Generating: {
      on: {
        GenerateSucceeded: {
          target: 'GeneratingSucceeded',
          actions: ['cleanError'],
        },
        GenerateFailed: {
          target: 'GeneratingFailed',
          actions: ['setError'],
        },
      },
    },
    GeneratingFailed: {
      on: {
        Generate: 'Generating',
      },
    },
    GeneratingSucceeded: {
      on: {
        Generate: 'Generating',
        Apply: 'Applying',
      },
    },
    Applying: {
      on: {
        ApplySucceeded: {
          target: 'ApplyingSucceeded',
          actions: ['cleanError'],
        },
        ApplyFailed: {
          target: 'ApplyingFailed',
          actions: ['setError'],
        },
        Generate: {
          target: 'Generating',
          actions: ['cleanError'],
        },
      },
    },
    ApplyingFailed: {
      on: {
        Apply: 'Applying',
        Generate: 'Generating',
      },
    },
    ApplyingSucceeded: {
      on: {
        Apply: 'Applying',
        Generate: 'Generating',
      },
    },
  },
};
